import { useCallback, useState } from "react";
export var useMenuState = function () {
    var _a = useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var isOpen = Boolean(anchorEl);
    var open = useCallback(function (event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var close = useCallback(function () {
        setAnchorEl(null);
    }, []);
    return {
        anchorEl: anchorEl,
        isOpen: isOpen,
        open: open,
        close: close,
    };
};
//# sourceMappingURL=useMenuState.js.map